import { render, staticRenderFns } from "./GTemplateCard.vue?vue&type=template&id=3a38466a&scoped=true&"
import script from "./GTemplateCard.vue?vue&type=script&lang=ts&"
export * from "./GTemplateCard.vue?vue&type=script&lang=ts&"
import style0 from "./GTemplateCard.vue?vue&type=style&index=0&id=3a38466a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38466a",
  null
  
)

export default component.exports